import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { PartnerRelationship } from './models/PartnerRelationship';
import { GlobalService } from '../core/global.service';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { RelationshipType, Partner, RelationshipDataItem } from './models/partner';
import { PartnerUser, Privilege, PrivilegeGroup } from './models';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class PartnerService {

  uniquePrivileges: any[] = [];

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private _http: HttpClient, private _global: GlobalService) { }

  getSourcePartners(SearchText: string, PartnerType: RelationshipType): Observable<any> {
    const api = (<any>_GlobalNS).api.partner.sourceData;
    const params = new HttpParams().set('RelationshipTypeId', PartnerType.RelationshipTypeId.toString()).set('SearchText', SearchText);
    return this._http.get<any>(`${api}`, { params });
  }

  findByTextandRelationshipType(txt: string, relationshipTypeId: number): Observable<RelationshipDataItem> {
    const api = (<any>_GlobalNS).api.relationship.relationshipDataItem;
    const params = new HttpParams().set('RelationshipTypeId', relationshipTypeId.toString()).set('SearchText', txt);
    return this._http.get<any>(`${api}`, { params });
  }

  assetGroupSearchObservable(sSubject: Subject<string>, relationshipType: RelationshipType): Observable<any> {
    return sSubject.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap((value) => {
        return this.findByTextandRelationshipType(value, relationshipType.RelationshipTypeId);
      }
      ));
  }

  create(PartnerCreateInstance: PartnerRelationship): Observable<PartnerRelationship[]> {
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);
    const api = (<any>_GlobalNS).api.partner.createPartner;
    return this._http.post<any>(`${api}&eqrf=${eqrf}`, PartnerCreateInstance, this.httpOptions);
  }

  update(PartnerUpdateInstance: PartnerRelationship): Observable<PartnerRelationship[]> {
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);
    const api = (<any>_GlobalNS).api.partner.updatePartnership;
    return this._http.post<any>(`${api}&eqrf=${eqrf}`, PartnerUpdateInstance, this.httpOptions);
  }

  deactivate(RelationID: number, personid: number): Observable<PartnerRelationship[]> {
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);
    const api = (<any>_GlobalNS).api.partner.deactivatePartner;
    const params = { 'RelationshipID': RelationID, 'PersonId': personid };
    return this._http.post<any>(`${api}&eqrf=${eqrf}`, params, this.httpOptions);
  }

  // reusable function to get privileges based on privileges and group privileges.
  getUniquePrivileges(privilegeGroups: PrivilegeGroup[], privileges: Privilege[]): Privilege[] {
    this.uniquePrivileges = [];
    if (privileges !== undefined && privileges.length) {
      privileges.map(item => {
        this.uniquePrivileges.push(item);
      });
    }
    if (privilegeGroups !== undefined && privilegeGroups.length) {
      privilegeGroups.map((privilegeGroup: PrivilegeGroup) => {
        privilegeGroup.Privileges.map((privilege: Privilege) => {
          if (!this.uniquePrivileges.some(item => item.PrivilegeId === privilege.PrivilegeId)) {
            this.uniquePrivileges.push(privilege);
          }
        });
      });
    }
    return this.uniquePrivileges;
  }

}

